import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function TechTourADNode(props) {
    return <NodeWithMultipleHandles {...props} nodeType="tech_tour_ad" />;
}
